// Convert an image File to another format (png <-> jpg) via canvas.
// Returns a new File with the target extension. Assumes source dimensions
// are already within limits (caller enforces).
export async function convertImage(
  source: File,
  target: "png" | "jpg"
): Promise<File> {
  const url = URL.createObjectURL(source);
  try {
    const img = await new Promise<HTMLImageElement>((resolve, reject) => {
      const el = new Image();
      el.onload = () => resolve(el);
      el.onerror = () => reject(new Error("讀取圖片失敗"));
      el.src = url;
    });
    const canvas = document.createElement("canvas");
    canvas.width = img.naturalWidth;
    canvas.height = img.naturalHeight;
    const ctx = canvas.getContext("2d");
    if (!ctx) throw new Error("Canvas 不可用");
    if (target === "jpg") {
      // Flatten transparency onto white for JPG
      ctx.fillStyle = "#ffffff";
      ctx.fillRect(0, 0, canvas.width, canvas.height);
    }
    ctx.drawImage(img, 0, 0);
    const mime = target === "png" ? "image/png" : "image/jpeg";
    const blob = await new Promise<Blob>((resolve, reject) => {
      canvas.toBlob(
        (b) => (b ? resolve(b) : reject(new Error("轉檔失敗"))),
        mime,
        target === "jpg" ? 0.92 : undefined
      );
    });
    const base = source.name.replace(/\.(png|jpe?g)$/i, "");
    return new File([blob], `${base}.${target}`, { type: mime });
  } finally {
    URL.revokeObjectURL(url);
  }
}

export function extOf(file: File): "png" | "jpg" {
  return file.type === "image/png" ? "png" : "jpg";
}
